import {bool, cleanEnv, num, str, url} from 'envalid';
import {DEBUG_MODE_DISABLED_KEY} from '@/constants/storage';

declare global {
  interface Window {
    env: unknown;
  }
}

const env = cleanEnv(window.env, {
  API_BFF_URL: url(),
  DEBUG: bool({default: false}),
  GOOGLE_TAG_MANAGER_CONTAINER_ID: str(),
  LOGOUT_REDIRECT_URL: url({default: ''}),
  OAUTH_CLIENT_ID: str(),
  OAUTH_ISSUER: str(),
  OAUTH_RESPONSE_TYPE: str(),
  OAUTH_SCOPE: str(),
  ONE_TRUST_SITE_ID: str(),
  SENTRY_DSN: str(),
  SENTRY_ENVIRONMENT: str(),
  SENTRY_REPLAY_SESSION_SAMPLE_RATE: num({default: undefined}),
  URL_EN: url({default: ''}),
  URL_FR: url({default: ''}),
  URL_INT: url({default: ''}),
});

const resolveDebugFlag = (debugFromEnv: boolean): boolean => {
  if (!debugFromEnv) {
    return false;
  }

  if (sessionStorage.getItem(DEBUG_MODE_DISABLED_KEY) === 'true') {
    // One-shot: consume session flag so the next full reload re-enables DEBUG from env.
    sessionStorage.removeItem(DEBUG_MODE_DISABLED_KEY);
    return false;
  }

  return true;
};

export const disableDebugModeForNextLoad = (): void => {
  sessionStorage.setItem(DEBUG_MODE_DISABLED_KEY, 'true');
  window.location.reload();
};

export default {
  ...env,
  DEBUG: resolveDebugFlag(env.DEBUG),
};
